module.exports = __webpack_public_path__ + "img/info_circle.8db3b83a.svg";